import React from "react";
import "./AppBadge.scss";

/**
 * AppBadge — Reusable badge component matching UX_DESIGNS design system.
 *
 * Props:
 *   variant   — "default" | "secondary" | "outline" | "destructive"
 *   color     — optional color override: "primary" | "blue" | "emerald" | "amber" | "violet" | "rose"
 *   size      — "sm" | "md" (default: "md")
 *   dot       — show a pulsing dot (for live indicators)
 *   children  — badge text
 *   className — extra class
 */
const AppBadge = ({
  variant = "default",
  color,
  size = "md",
  dot = false,
  children,
  className = "",
  ...props
}) => {
  const classes = [
    "app-badge",
    `app-badge--${variant}`,
    size !== "md" ? `app-badge--${size}` : "",
    color ? `app-badge--color-${color}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} {...props}>
      {dot && <span className="app-badge__dot" />}
      {children}
    </span>
  );
};

export default AppBadge;
